import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {SmsDto} from "../../../models/auth/auth.model";
import {AuthService} from "../../../services/auth/auth.service";

@Component({
  selector: 'app-sms-send',
  templateUrl: './sms-send.component.html',
  styleUrls: ['./sms-send.component.scss']
})
export class SmsSendComponent implements OnInit, OnDestroy {

  form!: FormGroup;

  count!: number

  isEnableResend = false

  timerCount = '60'

  timer: any

  second!: string

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    this.initForm()
    this.initTimer()
  }

  ngOnDestroy() {
    localStorage.removeItem('time')
    clearInterval(this.timer)
  }

  initForm(): void {
    this.form = new FormGroup({
      smsCode: new FormControl('', [Validators.required, Validators.minLength(4)]),
    })
  }

  initTimer() {
    if (localStorage.getItem('time')) {
      const count = localStorage.getItem('time') || 0
      this.count = +count
      this.initWordSecond(this.count)
      this.timer = setInterval(() => {
        if (this.count !== 0) {
          this.count--
          localStorage.setItem('time', this.count.toString())
          this.initWordSecond(this.count)
        } else {
          this.isEnableResend = true
          clearInterval(this.timer)
        }
      }, 1000)
    } else {
      this.router.navigate(['/login'])
    }
  }

  initWordSecond(count: number) {

    if (this.translateService.currentLang === 'ru') {
      if (count === 0 || count % 10 === 0 || (count >= 5 && count <= 20)) {
        this.second = 'секунд'
      }
      if (count === 1 || count === 21 || count === 31 || count === 41 || count === 51) {
        this.second = 'секунду'
      }
      if (count > 1 && count < 5) {
        this.second = 'секунды'
      }
      if (count > 20 && count % 10 >= 2 && count % 10 <= 4) {
        this.second = 'секунды'
      }
      if (count > 20 && count % 10 >= 5) {
        this.second = 'секунд'
      }
    } else {
      this.second = 'секунд'
    }
  }

  resendSMS() {
    localStorage.setItem('time', this.timerCount)

    this.authService.resendSmsCode().subscribe({
      next: () => {
        this.isEnableResend = false
        this.initTimer()
      },
      error: () => {
        this.isEnableResend = false
      }
    })
  }

  sendForm() {
    const sms: SmsDto = {
      otp_code: this.form.get('smsCode')?.value
    }
    this.authService.loginFromSms(sms).subscribe({
      next: (res) => {
        this.authService.finalAuth(res.token)
      },
    })
  }

}
